import { getSession } from "next-auth/react"

export const getOrganizationPagePath = async () => {
  const session = await getSession()

  if (session) {
    return `/org/${session.organizationId}`
  }
}
